import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import Button from 'components/ui/Button';
import styled from 'styled-components';
import { stationsShape } from 'constants/propTypes';
import StationSelectField from 'components/ui/StationSelectField';

const SwapButton = styled(Button)`
  ${({ visible }) => (visible ? '' : 'visibility: hidden')};
  width: 28px;
  height: 28px;

  & > div {
    margin-top: -5px;
    margin-left: 1px;
    font-size: 24px;
    line-height: 26px;
  }
`;

const SelectFieldContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  flex-direction: ${({ multicity }) => (multicity ? 'column' : 'initial')};
`;

const StationSelection = ({
  intl: { formatMessage },
  stations,
  swapOriginDestination,
  odAlreadySelected,
  originKey,
  destinationKey,
  title,
  multicity,
  originOnChange,
  destinationOnChange,
  originValue,
  destinationValue
}) => (
  <SelectFieldContainer multicity={multicity} className="station-selection-container">
    {multicity ? <FormattedMessage id={`journeySummaryBox.${title}`} /> : null}
    <StationSelectField
      label={formatMessage({ id: 'bookingMagnet.from' })}
      width={multicity ? '100%' : '48%'}
      value={originValue}
      onChange={originOnChange}
      stations={stations}
      id={originKey}
    />
    {!multicity && (
      <SwapButton
        onClick={swapOriginDestination}
        type="button"
        label="↔"
        space="vertical"
        id="swap-button"
        visible={odAlreadySelected}
        data-testid="swap-button"
      />
    )}
    <StationSelectField
      label={formatMessage({ id: 'bookingMagnet.to' })}
      width={multicity ? '100%' : '48%'}
      value={destinationValue}
      onChange={destinationOnChange}
      stations={stations}
      id={destinationKey}
    />
  </SelectFieldContainer>
);

StationSelection.propTypes = {
  stations: stationsShape,
  swapOriginDestination: PropTypes.func,
  odAlreadySelected: PropTypes.bool,
  originKey: PropTypes.string,
  destinationKey: PropTypes.string,
  title: PropTypes.string,
  multicity: PropTypes.bool,
  originOnChange: PropTypes.func,
  destinationOnChange: PropTypes.func,
  originValue: PropTypes.string,
  destinationValue: PropTypes.string,
  intl: intlShape
};

export default StationSelection;
